import './Header.scss';

const Header = () => (
  <header>
    <nav className="navbar d-flex justify-content-center">
      <div className="container-fluid  d-flex justify-content-center">
        <a className="navbar-brand" href="/">
          game
          <span>
            Z
          </span>
          one
        </a>
      </div>
    </nav>
  </header>
);

export default Header;
